var Component = require("vue-loader/lib/component-normalizer")(
  /* name */
  "Breadcrumbs",
  /* script */
  require("!!buble-loader!vue-loader/lib/selector?type=script&index=0!./../../../node_modules/eslint-loader/index.js!./Breadcrumbs.vue"),
  /* template */
  require("!!vue-loader/lib/template-compiler?id=data-v-7c49e469!vue-loader/lib/template-loader?raw&engine=pug!vue-loader/lib/selector?type=template&index=0!./../../../node_modules/eslint-loader/index.js!./Breadcrumbs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/breadcrumbs/Breadcrumbs.vue
// module id = 90
// module chunks = 0